import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import Chatbot from './components/feature/Chatbot'

const __BASE_PATH__ = import.meta.env.BASE_URL || '/'

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <Chatbot />
    </BrowserRouter>
  )
}

export default App
